<script setup>
import { computed } from 'vue';
import UserAvatarWithName from 'dashboard/components/widgets/UserAvatarWithName.vue';
import CardLabels from 'dashboard/components/widgets/conversation/conversationCardComponents/CardLabels.vue';
import SLAViewDetails from './SLAViewDetails.vue';
const props = defineProps({
  slaName: {
    type: String,
    required: true,
  },
  conversationId: {
    type: Number,
    required: true,
  },
  conversation: {
    type: Object,
    required: true,
  },
  slaEvents: {
    type: Array,
    default: () => [],
  },
});

const conversationLabels = computed(() => {
  return props.conversation.labels
    ? props.conversation.labels.split(',').map(item => item.trim())
    : [];
});

const routerParams = computed(() => ({
  name: 'inbox_conversation',
  params: { conversation_id: props.conversationId },
}));
</script>

<template>
  <div
    class="grid min-h-16 w-full grid-cols-12 content-center items-center gap-4 border-b border-auth-border px-5 py-0 last:border-b-0 dark:border-auth-border-dark"
  >
    <div
      class="col-span-6 flex items-center gap-2 px-0 py-2 text-sm tracking-[0.03125rem] text-auth-text dark:text-auth-text-dark rtl:text-right"
    >
      <router-link
        :to="routerParams"
        class="font-medium text-auth-text hover:text-auth-action focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-auth-action dark:text-auth-text-dark dark:hover:text-auth-accent dark:focus-visible:ring-auth-accent"
      >
        {{ `#${conversationId}` }}
      </router-link>
      <span class="text-auth-muted dark:text-auth-muted-dark">
        {{ $t('SLA_REPORTS.WITH') }}
      </span>
      <span class="truncate capitalize text-auth-text dark:text-auth-text-dark">
        {{ conversation.contact.name }}
      </span>
      <CardLabels
        v-if="conversationLabels.length"
        class="w-[60%]"
        :conversation-id="conversationId"
        :conversation-labels="conversationLabels"
      />
    </div>
    <div
      class="col-span-2 flex items-center px-0 py-2 text-left text-sm capitalize tracking-[0.03125rem] text-auth-text dark:text-auth-text-dark rtl:text-right"
    >
      {{ slaName }}
    </div>
    <div class="flex items-center col-span-2 gap-2">
      <UserAvatarWithName
        v-if="conversation.assignee"
        :user="conversation.assignee"
      />
      <span v-else class="text-auth-muted dark:text-auth-muted-dark">
        ---
      </span>
    </div>
    <SLAViewDetails :sla-events="slaEvents" />
  </div>
</template>
